<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Harry was born on July 20, 1934 in Jersey City, New Jersey, to Italian immigrants. His education culminated with the graduation from James J Ferris High School in Jersey City. He volunteered for the army draft and after six months of intense training in California at Fort Ord, he was deployed to Schweinfurt, Germany for 18 months during the Cold War and achieved the rank of Specialist-3 as a training aid NCO. Shortly after arriving home, he married and had two daughters and now has five grandchildren. He attended supervisor and management courses at Rutgers University while employed by the New Jersey Turnpike Authority for 27 years as a section manager. He is an avid gardener and is known for his delicious tomatoes and figs. He now resides in the town of Secaucus, New Jersey, for the past 50 years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1ffa954b